import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { LanguageSVG } from '@common_components/svg/language.svg';

const LanguageIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <LanguageSVG/>
    </div>
  );
};

export { LanguageIcon };
